import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from './app.component';

import { environment } from '../environments/environment';
import { ToolsReflexionsverhaltenComponent } from './tools-reflexionsverhalten/tools-reflexionsverhalten.component';





@NgModule({
  declarations: [
    AppComponent,
    ToolsReflexionsverhaltenComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    environment.production ? ServiceWorkerModule.register('/ngsw-worker.js') : [],
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/m.altmann/Documents/Projekte/telegärtner/tg-pwa/src/app/app.module.ts